import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PageObjectService } from '@Core/models/proprietary/page/page-object.service';
import { PageState } from '@Core/models/proprietary/page/page.state';

@Component({
    standalone: false,
    selector: 'required-event-dialog',
    templateUrl: './required-event-dialog.component.html',
    providers: []
})
export class RequiredEventDialogComponent {
    @Select(PageState.missingEvents)
    missingEvents$: Observable<string[]>;

    protected parentActiveModal: NgbActiveModal;

    constructor(private injector: Injector, private activeModal: NgbActiveModal, private pageOS: PageObjectService) {
        this.parentActiveModal = this.activeModal;
    }

    closeModal(returnValue: any) {
        this.pageOS.setMissingEvents([]);
        if (this.parentActiveModal) {
            this.parentActiveModal.close(returnValue);
            return;
        } else {
            throw 'Dialog did not properly set parentActiveModal in "initialize()"';
        }
    }

    close() {
        this.closeModal({ action: 'Close' });
    }

    cancel() {
        this.closeModal({ action: 'Cancel' });
    }
}
